<template>
<section id="ecommerce-header" v-show="AuthenticatedUserCheckoutStore.checkoutIsActive === 0">
    <div class="row">
        <div class="col-sm-12">
            <div class="ecommerce-header-items">
                <div class="result-toggler">
                    <button class="navbar-toggler shop-sidebar-toggler" type="button" data-toggle="collapse">
                        <span class="navbar-toggler-icon d-block d-lg-none">
                            <i data-feather="menu"></i>
                        </span>
                    </button>
                    <div class="search-results">{{ filteredCards().length }} cards</div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="body-content-overlay"></div>
<!-- E-commerce Search Bar Starts -->
<section id="ecommerce-searchbar" class="ecommerce-searchbar" v-if="this.AuthenticatedUserCheckoutStore.checkoutIsActive === 0">
  <div class="row mt-1">
    <div class="col-sm-12">
      <div class="input-group input-group-merge">
        <input
            type="text"
            class="form-control search-product"
            placeholder="Search Product"
            aria-label="Search..."
            aria-describedby="card-search"
            v-model="AuthenticatedUserCheckoutStore.search"
        />
        <div class="input-group-append">
          <span class="input-group-text border-0"><i data-feather="search" class="text-muted"></i></span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- E-commerce Search Bar Ends -->
<nav v-if="this.AuthenticatedUserCheckoutStore.checkoutIsActive === 0" class="row text-center mx-auto prev-item justify-content-center" aria-label="Page navigation example">
    <ul class="pagination pagination-success mt-2">
        <li class="page-item prev">
            <a class="page-link" @click="previousPage" href="javascript:void(0);" aria-label="Previous"></a>
        </li>
        <li v-for="n in lastPage()" class="page-item" :class="{ active: currentPage == n }">
            <a class="page-link" @click="changePage(n)" href="javascript:void(0);">{{ n }}</a>
        </li>
        <li class="page-item next">
            <a class="page-link" @click="nextPage" href="javascript:void(0);" aria-label="Next"></a>
        </li>
    </ul>
</nav>

<section id="ecommerce-products" class="grid-view" v-if="this.AuthenticatedUserCheckoutStore.checkoutIsActive === 0">
  <div class="card ecommerce-card" v-for="card in cards">
    <div>
        <p class="item-price text-primary px-1 pt-1 mb-0 text-center">Purchase Deadline: {{ card.purchase_by_date }}</p>
    </div>
    <div class="item-img text-center" style="min-height: 8.85rem;">
        <img class="img-fluid card-img-top" :src="card.image.replace('50x50', '100x100')" alt="img-placeholder" />
    </div>
    <div class="card-body">
        <div class="item-wrapper">
            <div class="item-rating">
                <h6 class="item-name text-primary">
                    {{ card.bank_name }}
                </h6>
            </div>
            <div>
                <h6 class="item-price">${{ card.price }}</h6>
            </div>
        </div>

        <p class="item-price mb-0">
            <span class="text-primary">Credit Limit: </span>
            <span v-html="card.credit_limit"></span>
        </p>
        <p class="item-price mb-0">
            <span class="text-primary">Date Opened:</span>
            {{ card.date_opened }}
        </p>
        <p class="item-price mb-0">
            <span class="text-primary">Reporting Period: </span>
            {{ card.reporting_period }}
        </p>
    </div>
    <div class="item-options text-center">
      <div class="item-wrapper">
        <div class="item-cost">
          <h4 class="item-price">${{ card.price }}</h4>
        </div>
      </div>
      <a href="javascript:void(0)" v-if="!filter(card)" @click="addToCart(card)" class="btn btn-primary btn-cart">
        <i data-feather="shopping-cart"></i>
        <span class="add-to-cart" >Add to Cart</span>
      </a>
      <a href="javascript:void(0)" v-else  @click="checkout" class="btn btn-primary btn-cart">
        <i data-feather="shopping-cart"></i>
        <span class="add-to-cart" >View In Cart</span>
      </a>
    </div>
  </div>
</section>
<authorized-user-checkout></authorized-user-checkout>
</template>
<style>
.ecommerce-application .grid-view .ecommerce-card .item-img
{
  margin:auto !important;
}
</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import axios from 'axios'
    import moment from 'moment'
    import { useAuthenticatedUserCheckoutStore } from '../stores/AuthenticatedUserCheckoutStore.js'
    import Stepper from 'bs-stepper'
    import { fix, round, chain, divide, ceil, sum } from 'mathjs'

    export default {
        props: {
            cardData: {
                type: [Array, Object]
            },
            user:
            {
                type: [Array, Object]
            }
        },
        components: {
        },
        setup(props) {
            useAuthenticatedUserCheckoutStore().cards = props.cardData;
            !_.isEmpty(props.cardData) ? useAuthenticatedUserCheckoutStore().updatePrices():"";
            !_.isEmpty(props.cardData) ? useAuthenticatedUserCheckoutStore().updateBanks(): "";
            return {
                AuthenticatedUserCheckoutStore: useAuthenticatedUserCheckoutStore(),
                defaultCount: ref('100'),
                currentPage: ref('1')
            }
        },
        mounted() {
            this.AuthenticatedUserCheckoutStore.checkoutIsActive===0;
        },
        watch: {
            'AuthenticatedUserCheckoutStore.search'(value) {
                this.currentPage = 1;
            },
            'AuthenticatedUserCheckoutStore.selectedCards'(value) {
                this.currentPage = 1;
            },
            'AuthenticatedUserCheckoutStore.range.min'(value) {
                this.currentPage = 1;
            },
            'AuthenticatedUserCheckoutStore.range.max'(value) {
                this.currentPage = 1;
            },
        },
        computed: {
            cards()
            {
                let start = (this.currentPage - 1) * this.defaultCount,
                end = this.currentPage * this.defaultCount;
                if (this.currentPage == this.lastPage()) {
                    end = this.filteredCards().length;
                }
                return _.slice(this.filteredCards(), start, end)
            }
        },
        methods: {
            filter($card)
            {
                if(_.findIndex(this.AuthenticatedUserCheckoutStore.cartItems, function(card) { return card.card_id == $card.card_id; }) == -1)
                {
                    return false;
                }
                else
                {
                    return true;
                }
            }
            ,
            addToCart($card)
            {
                if(_.findIndex(this.AuthenticatedUserCheckoutStore.cartItems, function(card) { return card.card_id == $card.card_id; }) == -1) {
                    this.AuthenticatedUserCheckoutStore.cartItems.push($card);
                    this.AuthenticatedUserCheckoutStore.total = fix(sum(this.AuthenticatedUserCheckoutStore.total, $card.price),2);
                    setTimeout(() => {
                        feather.replace();
                        const dropdown = new PerfectScrollbar('.scrollable-container');
                    }, 2000)
                }
            },
            changePage(n)
            {
                this.currentPage = n;
            },
            previousPage()
            {
                if ((this.currentPage - 1) > 0) {
                    this.currentPage--;
                }
            },
            nextPage()
            {
                if ((this.currentPage + 1) <= this.lastPage()) {
                    this.currentPage++;
                }
            },
            filteredCards()
            {
                let $this = this;
                if ($this.AuthenticatedUserCheckoutStore.search != '' && $this.AuthenticatedUserCheckoutStore.selectedCards.length > 0) {
                    return _.filter($this.cardData, function(card) {
                        return card.bank_name.toLowerCase().includes($this.AuthenticatedUserCheckoutStore.search.toLowerCase())
                        &&
                        _.includes($this.AuthenticatedUserCheckoutStore.selectedCards, card.bank_name)
                        &&
                        round(card.price) >= round($this.AuthenticatedUserCheckoutStore.range.min)
                        &&
                        round(card.price) <= round($this.AuthenticatedUserCheckoutStore.range.max);
                    });
                }
                else if ($this.AuthenticatedUserCheckoutStore.search != '') {
                    return _.filter($this.cardData, function(card) {
                        return card.bank_name.toLowerCase().includes($this.AuthenticatedUserCheckoutStore.search.toLowerCase())
                        &&
                        round(card.price) >= round($this.AuthenticatedUserCheckoutStore.range.min)
                        &&
                        round(card.price) <= round($this.AuthenticatedUserCheckoutStore.range.max);
                    });
                }
                else if ($this.AuthenticatedUserCheckoutStore.selectedCards.length > 0) {
                    return _.filter($this.cardData, function(card) {
                        return _.includes($this.AuthenticatedUserCheckoutStore.selectedCards, card.bank_name)
                        &&
                        round(card.price) >= round($this.AuthenticatedUserCheckoutStore.range.min)
                        &&
                        round(card.price) <= round($this.AuthenticatedUserCheckoutStore.range.max);
                    });
                }
                else if ($this.AuthenticatedUserCheckoutStore.range.min != 0 && $this.AuthenticatedUserCheckoutStore.range.max != 0) {
                    return _.filter($this.cardData, function(card) {
                        return round(card.price) >= round($this.AuthenticatedUserCheckoutStore.range.min)
                        &&
                        round(card.price) <= round($this.AuthenticatedUserCheckoutStore.range.max);
                    });
                }
                return $this.cardData;
            },
            lastPage()
            {
                return chain(this.filteredCards().length).divide(this.defaultCount).ceil().value;
            },
            checkout()
            {
                this.AuthenticatedUserCheckoutStore.checkoutIsActive = 1;
                document.querySelector(".content-detached").classList.remove("content-detached", "content-right");
            }
        }
    }
</script>
